import React from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import AliceCarousel from "react-alice-carousel";
import founder from "../../assets/founder1.jpg";
import Meenakshi from "../../assets/teachers/Minakshi2.png"
import Maninder from "../../assets/teachers/Maninder2.png"

export default function Tutor() {
  const tutorData = [
    {
      name: "Manish Garg",
      experience: "6+ years",
      image: founder,
      description:
        `An experienced and passionate educator. He uses personalized teaching techniques to help students understand complex 
         concepts and improve their academic performance`,
    },
    {
      name: "Meenakshi Barman",
      experience: "10+ years",
      image: Meenakshi,
      description:
        `With over 10 years of teaching experience, 
         A dedicated educator who brings a deep understanding of 
        academic excellence and a passion for guiding students to reach their full potential.`,
    },
    {
      name: "Maninder Singh",
      experience: "2+ years",
      image: Maninder,
      description:
        `A passionate and enthusiastic educator, committed to helping students build a strong foundation for success in their academic journey.`,
    },
  ];

  const responsive = {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 3 },
  };

  return (
    <div className="container mt-5 mx-auto">
      <h5 className="orange-text text-center fw-bold p-3">Team</h5>
      <h2 className="blue-text text-center fw-bolder p-3">Meet Our Team</h2>
      <AliceCarousel
        responsive={responsive}
        mouseDragEnabled
        buttonsDisabled
        dotsDisabled
      >
        {tutorData.map((tutor, index) => (
          <div key={index} className="p-2">
            <div
              className="card h-100 text-center mx-3"
              style={{ cursor: "pointer" }}
            >
              <div className="mx-auto mt-3">
                <div>
                  <img
                    src={tutor.image}
                    alt={tutor.name}
                    className="mx-auto mt-2 assests rounded-circle mb-4"
                    width="200"
                    height="200"
                  />
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title">{tutor.name}</h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  {tutor.experience} of experience
                </h6>
                <p className="card-text mt-3 p-3">{tutor.description}</p>
              </div>
            </div>
          </div>
        ))}
      </AliceCarousel>
    </div>
  );
}
